import { BrandPayoutRequest, PayoutHistory } from '../types/payouts';

export const mockPendingPayouts: BrandPayoutRequest[] = [
  {
    id: "1",
    affiliateId: "aff1",
    name: "John Doe",
    username: "johndoe",
    avatar: "https://i.pravatar.cc/150?img=1",
    email: "john@example.com",
    payoutStatus: "Pending",
    paymentMethod: "Paypal",
    paymentInformation: "john@example.com",
    code: "PAY123",
    amount: 150.00,
  },
  {
    id: "2",
    affiliateId: "aff2",
    name: "Jane Smith",
    username: "janesmith",
    avatar: "https://i.pravatar.cc/150?img=2",
    email: "jane@example.com",
    payoutStatus: "Processing",
    paymentMethod: "ACH",
    paymentInformation: "stripe_123",
    code: "PAY456",
    amount: 275.50,
  },
  {
    id: "3",
    affiliateId: "aff3",
    name: "Mike Johnson",
    username: "mikej",
    avatar: "https://i.pravatar.cc/150?img=3",
    email: "mike@example.com",
    payoutStatus: "Completed",
    paymentMethod: "ACH",
    paymentInformation: "payoneer_789",
    code: "PAY789",
    amount: 420.75,
  },
]; 

export const mockPayoutHistory: PayoutHistory[] = [
  {
    id: '1',
    affiliateId: '1',
    name: 'Jackie paul',
    username: '@jakiee',
    avatar: 'https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250',
    email: 'Jakie12@gmail.com',
    payoutStatus: 'Completed',
    paymentMethod: 'Paypal',
    paymentInformation: 'paypal@gmail.com',
    code: 'CODE13',
    amount: 160,
    payoutDate: 'Nov 23, 2024',
  },
  {
    id: '2',
    affiliateId: '2',
    name: 'Jackie paul',
    username: '@jakiee',
    avatar: "https://www.gravatar.com/avatar/3c7d99fe281ecd3bcd65ab915bac6dd5?s=250",
    email: "Jakie12@gmail.com",
    payoutStatus: "Completed",
    paymentMethod: "ACH",
    paymentInformation: "creditcardinfo",
    code: "CODE13",
    amount: 160,
    payoutDate: "Nov 23, 2024",
  },
];
